module.exports = __webpack_public_path__ + "assets/images/openClosedOfficePlan-03.339477eed35e6ba4c0eaa63a707dd796.svg";